import React from 'react'
import { ASDesc } from '../AllStarGame/styles'

export const VotingDescription: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <ASDesc>
      <ul>
        <li>{`Open June 16th - June 23rd`}</li>
        <li>{`Starting 11 for each team determined by fan vote`}</li>
        <li>{`Select 8 players per conference: 2 Attack, 2 Midfield, 2 Defense(includes long-stick midfielders), 1 Faceoff, & 1 Goalie per ballot`}</li>
        <li>
          PLL Nation members submit up to 5 ballots per vote based on status. You can
          vote <strong>once per day</strong>
        </li>
      </ul>
    </ASDesc>
  )
}
